import { IDrivesLoadingToggleAction } from './types';
import { AT_DRIVES_LOADING_SET } from './constants';

export const drivesLoadingSet = (
    isLoading: boolean
): IDrivesLoadingToggleAction => ({
    type: AT_DRIVES_LOADING_SET,
    isLoading
});
